import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga";

import { ApiHandler, contactHandler } from "./core/services/handlers";

import Main from "./core/pages/main";
import ErrorContainer from "./core/components/errorContainer";
import { Loader } from "./core/components/loader";

function App({ customerEmail, authCode, executedBy, test }) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    // Google Analytics integration
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_KEY);
  }, []);

  useEffect(() => {
    ApiHandler(
      `get?code=${authCode}&email=${encodeURIComponent(customerEmail)}`
    )
      .then((response) => {
        setData(response.data);

        setTimeout(() => {
          setLoader(false);
        }, 500);
      })
      .catch((err) => {
        setLoader(false);
        setError(true);
      });
  }, [authCode, customerEmail]);

  return !error ? (
    <>
      {loader ? (
        <Loader isFullScreen={true} />
      ) : (
        <Main
          data={data}
          executedBy={executedBy}
          authCode={authCode}
          customerEmail={customerEmail}
        />
      )}
    </>
  ) : (
    <ErrorContainer
      handleClick={contactHandler}
      isFullScreen={true}
      label={t("epc_contact_message_btnLabel")}
    />
  );
}

export default App;
